import type { Content } from '~/i18n/schema';
import type { Locale } from '~/i18n/config';
import { usePageContext } from '~/renderer/PageContextProvider';

/** Returns the typed content bundle for the current page's locale. */
export function useContent(): Content {
  return usePageContext().content;
}

/** Returns just the locale for the current page. */
export function useLocale(): Locale {
  return usePageContext().locale;
}
